<template>
  <div class="nopads">
      <!-- Header of collapsable item -->
      <div class="col-12 d-flex justify-content-between align-items-center pb-1">
          <div class="flex-grow-1">
              <h4 class="form-header pointer hover-header" @click.stop="inspectionsVisible = !inspectionsVisible">
                  {{ $t('contract_reports.area_inspections') }} ({{ inspections.length }})
              </h4>
          </div>
          <div
              v-if="loading"
              id="loader"
              class="spinner-section"
          />
          <div v-else class="ms-2 px-2" @click.stop="inspectionsVisible = !inspectionsVisible">
              <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:inspectionsVisible }"/>
          </div>
      </div>
      <!-- Collapsable content -->
      <div class="routa-collapse" :class="{ collapsed: inspectionsVisible }">
      <!-- Summary -->
      <div class="col-12 text-center">
          <div class="row row-cols-1 row-cols-md-5 g-2 mb-2">
              <div class="col">
                  <div class="card border-dark text-center">
                      <div class="card-header bg-dark text-white">
                          {{ $t('contract_reports.inspections_equipment_result_options.total') }}
                      </div>
                      <div class="card-body">
                          <p class="summary-number total text-center">{{ resultTotal }}</p>
                      </div>
                  </div>
              </div>

              <div class="col">
                  <div class="card border-success text-center">
                      <div class="card-header bg-success text-white">
                          {{ $t('contract_reports.inspections_equipment_result_options.ok') }}
                      </div>
                      <div class="card-body">
                          <p class="summary-number completed text-center">{{ resultOk }}</p>
                      </div>
                  </div>
              </div>

              <div class="col">
                  <div class="card border-warning text-center">
                      <div class="card-header bg-warning text-dark">
                          {{ $t('contract_reports.inspections_equipment_result_options.defects') }}
                      </div>
                      <div class="card-body">
                          <p class="summary-number open text-center">{{ resultDefect }}</p>
                      </div>
                  </div>
              </div>

              <div class="col">
                  <div class="card border-danger text-center">
                      <div class="card-header bg-danger text-white">
                          {{ $t('contract_reports.inspections_equipment_result_options.ban') }}
                      </div>
                      <div class="card-body">
                          <p class="summary-number ban text-center">{{ resultBan }}</p>
                      </div>
                  </div>
              </div>

              <div class="col">
                  <div class="card border-secondary text-center">
                      <div class="card-header bg-secondary text-white">
                          {{ $t('contract_reports.inspections_equipment_result_options.skipped') }}
                      </div>
                      <div class="card-body">
                          <p class="summary-number text-center">{{ resultSkip }}</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <area-contract-report-list
        :results="inspections"
        @inspection-selected="showInspectionReport"
      />
    </div>

    <base-modal
      v-if="inspection"
      size="lg"
      hide-header
      hide-footer
      @close="inspectionVisible = false"
    >
      <area-report-details
        id="details"
        ref="details"
        :report-details="inspection"
        :is-observer="isObserver"
        @close="inspection = null"
        @close-and-update="closeAndUpdate"
      />
    </base-modal>
    <hr class="report-divider nopads">
  </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import {inspectionState} from "@/components/mixins/AreaReportMixin";
import AreaReportDetails from "@/components/area/areareport/AreaReportDetails";
import AreaContractReportList from "@/components/area/areareport/AreaContractReportList";
import BaseModal from "@/components/BaseModal";

export default {
    name: "ContractReportAreaInspections",
    components: {BaseModal, AreaReportDetails, AreaContractReportList},
    mixins: [restApi, inspectionState],
    props: {
        searchParams: {
            type: Object,
            default() {
                return null
            }
        },
        isObserver: Boolean
    },
    data: function () {
        return {
            loading: false,
            inspections: [],
            inspection: null,
            resultTotal: 0,
            resultOk: 0,
            resultDefect: 0,
            resultBan: 0,
            resultSkip: 0,
            inspectionsVisible: false,
            inspectionVisible: false
        }
    },
    watch: {
        searchParams: function () {
            this.fetchInspections()
        }
    },
    mounted() {
        this.fetchInspections()
    },
    methods: {
        fetchInspections: function () {
            if (this.searchParams && this.searchParams.dateTo && this.searchParams.dateFrom && this.searchParams.contract) {
                let params = {
                    from: new Date(this.searchParams.dateFrom).toISOString(),
                    to: new Date(this.searchParams.dateTo).toISOString(),
                    contract: this.searchParams.contract
                }
                this.inspections = []
                this.loading = true
                this.$emit('loading', true)
                this.restFetchParams(this.areaReportUrl, params, this.handleResponse, this.handleFail)
            }
        },
        handleResponse: function (response) {
            this.loading = false
            this.$emit('loading', false)
            this.inspections = response.data
            this.setSummaryData()
        },
        handleFail: function () {
            this.loading = false
            this.$emit('loading', false)
        },
        showInspectionReport(item) {
            this.inspection = item
        },
        closeAndUpdate() {
            this.inspection = null
            this.inspectionsVisible = false
            this.fetchInspections()
        },
        setSummaryData() {
            if (this.inspections) {
                this.inspections.forEach(item => {
                    item.equipment_inspection_results.forEach(inspection_result => {
                        this.resultTotal++
                        switch (inspection_result.result) {
                            case inspectionState.resultOk:
                                this.resultOk++
                                break
                            case inspectionState.resultDefect:
                                this.resultDefect++
                                break
                            case inspectionState.resultBan:
                                this.resultBan++
                                break
                            case inspectionState.resultSkip:
                                this.resultSkip++
                                break
                        }
                    })
                })
            }
        }
    }
}
</script>
